import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import { TextField } from '../../atoms';
import { getLoadingSelector } from '../../utils/asyncHelpers';
import { Row, Col, Button, Spin } from 'antd';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormActions } from '../../components';
import { Link } from 'react-router-dom';
import { FORM_CLASSIFIERS_SUB_EDIT } from '../../constants/formKeys';
import { getClassifierSubChange } from '../../reducers/classifiersReducer';
import * as actions from '../../actions/actionCreators/classifiersActionCreators';
import {
  classifierGeneralItemField,
  classifierGeneralItemLangField,
} from '../../constants/classifier';
import validateSchema from './validateSchema';
import classifiersStore from '../../utils/classifiersStore';
import FormStateToRedux from '../FormStateToRedux';
import { makeRffValidateFromLegacy } from '../rffLegacyValidateAdapter';

export class ClassifierSubEdit extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isEdit: PropTypes.bool.isRequired,
    classifierCode: PropTypes.string,
    classifierSubId: PropTypes.string,
    selectedCode: PropTypes.string,
    initialValues: PropTypes.object,
    changeClassifierSub: PropTypes.func.isRequired,
    fetchClassifierSub: PropTypes.func.isRequired,
  };

  onSubmit = async (values) => {
    const {
      classifierSubId,
      onComplete,
      changeClassifierSub,
      fetchClassifierSub,
    } = this.props;

    await changeClassifierSub(classifierSubId, values);
    fetchClassifierSub(classifierSubId);
    onComplete();

    await classifiersStore.update();
  };

  render() {
    const {
      t,
      onCancel,
      isLoading,
      classifierCode,
      classifierSubId,
      selectedCode,
      initialValues: initialValuesProp,
      isEdit,
    } = this.props;

    // Convert Immutable objects to plain JS (parent passes lang as Immutable Map)
    const initialValues = initialValuesProp
      ? {
          ...initialValuesProp,
          [classifierGeneralItemField.LANG]: initialValuesProp[
            classifierGeneralItemField.LANG
          ]?.toJS
            ? initialValuesProp[classifierGeneralItemField.LANG].toJS()
            : initialValuesProp[classifierGeneralItemField.LANG] || {},
        }
      : {};

    const validate = makeRffValidateFromLegacy(
      validateSchema,
      this.props,
      initialValues
    );

    let id = initialValues[classifierGeneralItemField.ID];

    return (
      <Spin spinning={isLoading}>
        <Form
          onSubmit={this.onSubmit}
          initialValues={initialValues}
          validate={validate}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <FormStateToRedux form={FORM_CLASSIFIERS_SUB_EDIT} />
              <Row gutter={32}>
                <Col span={24}>
                  <Field
                    name={classifierGeneralItemField.CODE}
                    label={t('fieldCode')}
                    component={TextField}
                    disabled={isEdit}
                  />
                </Col>
              </Row>
              <Row gutter={32}>
                <Col span={12}>
                  <Field
                    name={`${classifierGeneralItemField.LANG}.${classifierGeneralItemLangField.EN}`}
                    label={t('fieldEn')}
                    component={TextField}
                  />
                </Col>
                <Col span={12}>
                  <Field
                    name={`${classifierGeneralItemField.LANG}.${classifierGeneralItemLangField.ET}`}
                    label={t('fieldEt')}
                    component={TextField}
                  />
                </Col>
              </Row>
              <FormActions>
                {selectedCode !== null && (
                  <Link
                    to={{
                      pathname: `/classifiers/${classifierCode}/${classifierSubId}/${initialValues.code}`,
                      data: id,
                    }}
                  >
                    <Button>{t('buttonSubValues')}</Button>
                  </Link>
                )}
                <Button onClick={onCancel}>{t('buttonCancel')}</Button>
                <Button htmlType="submit" type="primary">
                  {t('buttonSave')}
                </Button>
              </FormActions>
            </form>
          )}
        />
      </Spin>
    );
  }
}

const getIsLoading = getLoadingSelector(getClassifierSubChange);

const mapStateToProps = (state) => ({
  isLoading: getIsLoading(state),
});

const mapDispatchToProps = {
  changeClassifierSub: actions.changeClassifierSub,
  fetchClassifierSub: actions.fetchClassifierSub,
};

export default connect(mapStateToProps, mapDispatchToProps)(ClassifierSubEdit);
